import { t as toggleBooleanAttribute } from './toggleBooleanAttribute-Cp5m6OeZ.js';

/**
 * Toggles the `aria-expanded` state of its inner control button. The visual
 * reveal is handled entirely in CSS via the `group-has-aria-expanded` pattern,
 * so this element only needs to flip the attribute — no target manipulation.
 */
class ReadMore extends HTMLElement {
  /** @type {HTMLElement | null} */ #controller = this.querySelector('[aria-controls]');

  connectedCallback() {
    if (!this.#controller) return;
    this.#controller.addEventListener('click', () => this.#handleClick());
  }

  #handleClick() {
    toggleBooleanAttribute(this.#controller, 'aria-expanded');
  }
}

if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore);
}
